/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInstrumentLinks} from '../api'

 export const useQueryGetInstrumentLinks = createReactQueryHook('getInstrumentLinks', getInstrumentLinks)
